/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { BubbleMenu } from "@tiptap/react";
import { useUpdateLink } from "./use-update-link";
import { LinkSettingsDialog } from "cms/rich-text/simplicity-composer-tiptap/tiptap-extensions/simplicity-link/link-settings-dialog";

const LinkBubbleMenu = () => {
    
    const markType = "link";
    const { findSelection } = useUpdateLink();

    /**
     *  This function is called when the bubble menu should show
     */
    const shouldShow = (properties) => {
        // const { editor, view, state, oldState, from, to } = properties
        const editor = properties?.editor;
        findSelection();
        return editor.isActive(markType);
    };

    return (
        // BubbleMenu will fail to remove correctly without a wrapping div
        // https://github.com/ueberdosis/tiptap/issues/2658#issuecomment-1312664934
        <div>
            <BubbleMenu
                updateDelay={100}
                shouldShow={shouldShow}
                tippyOptions={{
                    placement: "bottom",
                    zIndex: 100,
                    maxWidth: "800px",
                }}
            >
                <LinkSettingsDialog />
            </BubbleMenu>
        </div>
    );
};
export { LinkBubbleMenu };
